(function () {
(function($) {
    const behavior = "polyu_theme.views-unformatted";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {
        init_checkboxes();
        init_reset_btn();
    });
    $(document).ajaxComplete(function() {
        init_checkboxes();
    });
    function init_checkboxes() {
        $(".views-exposed-form  .form-checkboxes").each(function() {
            const select_all_checkbox = $(this).find(".bef-toggle");
            if (select_all_checkbox.length == 0) return;
            const checkboxes = $(this).find(".bef-checkboxes");
            if (checkboxes.length == 0) return;
            if (checkboxes.find("input[type=checkbox]").length == checkboxes.find("input[type=checkbox][checked]").length) select_all_checkbox.addClass("active");
        });
    }
    function init_reset_btn() {
        $(".reset-btn").on("click", function(e) {
            if (e.target != $(this).find("input")[0]) $(this).find("input").trigger("click");
        });
    }
})(jQuery);


(function($) {
    const behavior = "polyu_theme.views-ug-programmes";
    var ug_filter_count = 0;
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{
            once(behavior, ".form--views-exposed-form-ug-programmes-find-your-programmes").forEach((block)=>{
                ug_find_program_show_count_filter();
                ug_wrap_second_filter();
            });
            context.querySelectorAll(".container--view--ug-programmes--programme-listing-with-grouping .views-infinite-scroll-content-wrapper").forEach((pattern)=>{
                ug_toggle_collapsible(pattern);
            });
        }
    };
    $(function() {
        ug_handler_find_program_custom_search_button();
        ug_find_program_show_filter_button();
        ug_program_az_remove_same_grouping();
        ug_program_listing_with_grouping_remove_same_grouping();
    });
    function ug_program_listing_with_grouping_remove_same_grouping() {
        var updating = false;
        $(".container--view--ug-programmes--programme-listing-with-grouping .views-infinite-scroll-content-wrapper").on("DOMSubtreeModified", function() {
            if (updating) return;
            var showed_faculty = [];
            $(this).find(".sorting-letter .faculty").each(function() {
                var faculty_id = $(this).data("id");
                if ($.inArray(faculty_id, showed_faculty) == "-1") showed_faculty.push(faculty_id);
                else {
                    updating = true;
                    $(this).parent().parent().prev().children(".programmes-items").append($(this).parent().next(".programmes-items").html());
                    $(this).parent().parent().remove();
                }
            });
            updating = false;
        });
    }
    function ug_program_az_remove_same_grouping() {
        $(".container--view--ug-programmes--programme-az .views-infinite-scroll-content-wrapper").on("DOMSubtreeModified", function() {
            var showed_letter = [];
            $(this).find(".sorting-letter img").each(function() {
                var letter = $(this).attr("class");
                if ($.inArray(letter, showed_letter) == "-1") showed_letter.push(letter);
                else {
                    $(this).attr("src", "");
                    $(this).css("width", "76px");
                }
            });
            console.log(showed_letter);
        });
    }
    function ug_handler_find_program_custom_search_button() {
        $(document).on("click", ".search_button", function(e) {
            $(".form-submit[value=Search]").click();
        });
    }
    function ug_find_program_show_filter_button() {
        const form = $(".form--views-exposed-form-ug-programmes-find-your-programmes");
        const show_filter_button = form.find(".show_filter");
        const second_filter = form.find(".second_filter");
        const hide_filter = 'Hide Filters <i class="fa-light fa-angle-up"></i>';
        const show_filter = "Show Filters <span class='filter-count'>" + ug_filter_count + '</span><i class="fa-light fa-angle-down"></i>';
        if (second_filter != "undefined") {
            if (second_filter.css("opacity") !== "0") show_filter_button.html(hide_filter);
            else show_filter_button.html(show_filter);
        }
    }
    function ug_find_program_show_count_filter() {
        const form = $(".form--views-exposed-form-ug-programmes-find-your-programmes");
        const fieldset = form.find(".fieldset");
        ug_filter_count = 0;
        fieldset.find("input[type=checkbox]").each(function() {
            if ($(this).is(":checked")) ug_filter_count++;
        });
    }
    function ug_wrap_second_filter() {
        const separatedSelectors = [
            // '.form--views-exposed-form-ug-programmes-find-your-programmes .form-item-ug-programmes-label-target-id-verf',
            '.form--views-exposed-form-ug-programmes-find-your-programmes fieldset[data-drupal-selector="edit-ug-programmes-faculty-school-target-id-verf"]',
            ".form--views-exposed-form-ug-programmes-find-your-programmes .form-actions"
        ];
        const separatedSelectorsString = separatedSelectors.join(", ");
        const form = $(".form--views-exposed-form-ug-programmes-find-your-programmes");
        if ($(".form--views-exposed-form-ug-programmes-find-your-programmes").find(".first_filter").length == 0) {
            $(separatedSelectorsString).wrapAll("<div class='second_filter' style=''></div>");
            form.find(".form-item-programme-keyword").append('<div class="search_button"><i class="fa-light fa-magnifying-glass"></i></div>');
            form.find(".form-item-programme-keyword").wrapAll("<div class='first_filter'></div>");
            form.find(".first_filter").append('<div class="show_filter ug">Show Filters <span class="filter-count">' + ug_filter_count + '</span><i class="fa-light fa-angle-down"></i></div>');
        }
        form.find(".show_filter").on("click", function(e) {
            if (form.find(".second_filter").hasClass("show")) form.find(".second_filter").removeClass("show");
            else form.find(".second_filter").addClass("show");
            form.find(".second_filter").slideToggle(null, null, function() {
                setTimeout(ug_find_program_show_filter_button(), 100);
            });
        });
    }
    function ug_toggle_collapsible(pattern) {
        const items = pattern.querySelectorAll(".programmes-row");
        if (items.length === 0) return;
        const toggle = (item, state)=>{
            item.classList.toggle("active", state);
        };
        items.forEach((item, i)=>{
            const arrow = item.querySelector(".sorting-letter");
            if (arrow === null) return;
            arrow.onclick = function() {
                let active = [
                    ...pattern.querySelectorAll(".programmes-row.active")
                ];
                var otherActiveElements = active.filter(function(element) {
                    return element !== item;
                });
                for(let j = 0; j < otherActiveElements.length; j++){
                    var active_content = active[j].querySelector(".sorting-letter").nextElementSibling;
                    active_content.style.maxHeight = null;
                    active[j].classList.remove("active");
                }
                item.classList.toggle("active");
                var isOpen_content = arrow.nextElementSibling;
                if (isOpen_content.style.maxHeight) isOpen_content.style.maxHeight = null;
                else isOpen_content.style.maxHeight = isOpen_content.scrollHeight + "px";
            };
        });
    }
})(jQuery);


(function($) {
    const behavior = "polyu_theme.views-pg-programmes";
    var pg_filter_count = 0;
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{
            once(behavior, ".form--views-exposed-form-pg-programmes-find-your-programmes").forEach((block)=>{
                pg_find_program_show_count_filter();
                pg_wrap_second_filter();
            });
            context.querySelectorAll(".container--view--pg-programmes--find-your-programmes .views-infinite-scroll-content-wrapper").forEach((pattern)=>{
                pg_toggle_collapsible(pattern);
            });
            context.querySelectorAll(".container--view--pg-programmes--programme-listing .views-infinite-scroll-content-wrapper").forEach((pattern)=>{
                pg_toggle_collapsible(pattern);
            });
        }
    };
    $(function() {
        pg_program_admission_year_filter_trim_entry();
        pg_handler_find_program_custom_search_button();
        pg_find_program_show_filter_button();
        pg_program_listing_remove_same_grouping();
        pg_find_your_program_remove_same_grouping();
    });
    function pg_program_admission_year_filter_trim_entry() {
        $('fieldset[data-drupal-selector="edit-pg-programmes-semester-term-value"] label').text(function() {
            return $(this).text().replaceAll("Entry", "").trim();
        });
    }
    function pg_program_listing_remove_same_grouping() {
        var updating = false;
        $(".container--view--pg-programmes--programme-listing .views-infinite-scroll-content-wrapper").on("DOMSubtreeModified", function() {
            if (updating) return;
            var showed_faculty = [];
            $(this).find(".sorting-letter .faculty").each(function() {
                var faculty_id = $(this).data("id");
                if ($.inArray(faculty_id, showed_faculty) == "-1") showed_faculty.push(faculty_id);
                else {
                    updating = true;
                    $(this).parent().parent().prev().children(".programmes-items").append($(this).parent().next(".programmes-items").html());
                    $(this).parent().parent().remove();
                }
            });
            updating = false;
        });
    }
    function pg_find_your_program_remove_same_grouping() {
        var updating = false;
        $(".container--view--pg-programmes--find-your-programmes .views-infinite-scroll-content-wrapper").on("DOMSubtreeModified", function() {
            if (updating) return;
            var showed_faculty = [];
            $(this).find(".sorting-letter .faculty").each(function() {
                var faculty_id = $(this).data("id");
                if ($.inArray(faculty_id, showed_faculty) == "-1") showed_faculty.push(faculty_id);
                else {
                    updating = true;
                    $(this).parent().parent().prev().children(".programmes-items").append($(this).parent().next(".programmes-items").html());
                    $(this).parent().parent().remove();
                }
            });
            updating = false;
        });
    }
    function pg_handler_find_program_custom_search_button() {
        $(document).on("click", ".search_button", function(e) {
            $(".form-submit[value=Search]").click();
        });
        $(".rpg_search_button").on("click", function(e) {
            $("#rpg_search").submit();
        });
        $(".tpg_search_button").on("click", function(e) {
            $("#tpg_search").submit();
        });
    }
    function pg_find_program_show_filter_button() {
        const form = $(".form--views-exposed-form-pg-programmes-find-your-programmes");
        const show_filter_button = form.find(".show_filter");
        const second_filter = form.find(".second_filter");
        const hide_filter = 'Hide Filters<i class="fa-light fa-angle-up"></i>';
        const show_filter = "Show Filters <span class='filter-count'>" + pg_filter_count + '</span><i class="fa-light fa-angle-down"></i>';
        if (second_filter != "undefined") {
            if (second_filter.css("display") !== "none") show_filter_button.html(hide_filter);
            else show_filter_button.html(show_filter);
        }
    }
    function pg_find_program_show_count_filter() {
        const form = $(".form--views-exposed-form-pg-programmes-find-your-programmes");
        const fieldset = form.find(".fieldset");
        pg_filter_count = 0;
        form.find(".fieldset input[type=checkbox]").each(function() {
            if ($(this).is(":checked")) pg_filter_count++;
        });
    }
    function pg_wrap_second_filter() {
        const form = $(".form--views-exposed-form-pg-programmes-find-your-programmes");
        const separatedSelectors = [
            ".form--views-exposed-form-pg-programmes-find-your-programmes .form-item-pg-programmes-faculty-school-target-id-verf",
            ".form--views-exposed-form-pg-programmes-find-your-programmes .form-item-pg-programmes-label-target-id-verf",
            ".form--views-exposed-form-pg-programmes-find-your-programmes .form-item-pg-programmes-study-mode-value",
            ".form--views-exposed-form-pg-programmes-find-your-programmes .form-composite",
            ".form--views-exposed-form-pg-programmes-find-your-programmes .form-actions"
        ];
        const separatedSelectorsString = separatedSelectors.join(", ");
        if (form.find(".first_filter").length == 0) {
            $(separatedSelectorsString).wrapAll("<div class='second_filter' style='display: none;'></div>");
            form.find(".form-item-programme-keyword").append('<div class="search_button"><i class="fa-light fa-magnifying-glass"></i></div>');
            form.find(".form-item-programme-keyword").wrapAll("<div class='first_filter'></div>");
            form.find(".first_filter").append('<div class="show_filter pg">Show Filters <span class="filter-count">' + pg_filter_count + '</span><i class="fa-light fa-angle-down"></i></div>');
        }
        form.find(".show_filter").on("click", function(e) {
            form.find(".second_filter").slideToggle(null, null, function() {
                setTimeout(pg_find_program_show_filter_button(), 100);
            });
        });
    }
    function pg_toggle_collapsible(pattern) {
        const items = pattern.querySelectorAll(".programmes-row");
        if (items.length === 0) return;
        const toggle = (item, state)=>{
            item.classList.toggle("active", state);
        };
        items.forEach((item, i)=>{
            const arrow = item.querySelector(".sorting-letter");
            if (arrow === null) return;
            arrow.onclick = function() {
                let active = [
                    ...pattern.querySelectorAll(".programmes-row.active")
                ];
                var otherActiveElements = active.filter(function(element) {
                    return element !== item;
                });
                for(let j = 0; j < otherActiveElements.length; j++){
                    var active_content = active[j].querySelector(".sorting-letter").nextElementSibling;
                    active_content.style.maxHeight = null;
                    active[j].classList.remove("active");
                }
                item.classList.toggle("active");
                var isOpen_content = arrow.nextElementSibling;
                if (isOpen_content.style.maxHeight) isOpen_content.style.maxHeight = null;
                else isOpen_content.style.maxHeight = isOpen_content.scrollHeight + "px";
            };
        });
    }
})(jQuery);


(function($) {
    const behavior = "polyu_theme.views-offers";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{
            offers_filter_toggle_select2();
            context.querySelectorAll(".container--view--offers .offers-wrapper").forEach((pattern)=>{
                offers_toggle_collapsible(pattern);
            });
        }
    };
    $(function() {});
    function offers_filter_toggle_select2() {
        if ($(".container--view--offers select").length > 0) $(".container--view--offers select").select2();
    }
    function offers_toggle_collapsible(pattern) {
        const items = pattern.querySelectorAll(".views-row");
        if (items.length === 0) return;
        const toggle = (item, state)=>{
            item.classList.toggle("active", state);
        };
        items.forEach((item, i)=>{
            const arrow = item.querySelector(".views-field-title");
            if (arrow === null) return;
            arrow.onclick = function() {
                let active = [
                    ...pattern.querySelectorAll(".views-row.active")
                ];
                var otherActiveElements = active.filter(function(element) {
                    return element !== item;
                });
                for(let j = 0; j < otherActiveElements.length; j++){
                    var active_content = active[j].querySelector(".views-field-title").nextElementSibling;
                    active_content.style.maxHeight = null;
                    active[j].classList.remove("active");
                }
                item.classList.toggle("active");
                var isOpen_content = arrow.nextElementSibling;
                if (isOpen_content.style.maxHeight) isOpen_content.style.maxHeight = null;
                else isOpen_content.style.maxHeight = isOpen_content.scrollHeight + "px";
            };
        });
    }
})(jQuery);


(function($) {
    const behavior = "polyu_theme.views-5_kinds_of_basic_info_local_non_jupas_";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{
            var count = 0;
            $(".basic-info-views-header-container").each(function() {
                count++;
                if ($(".container--view--5-kinds-of-basic-info-local-non-jupas---block-11").length) return;
                if (count > 1) $(this).remove();
            });
            var count2 = 0;
            $(".underline-decor").each(function() {
                count2++;
                if ($(".container--view--5-kinds-of-basic-info-local-non-jupas---block-11").length) return;
                if (count2 > 1) $(this).remove();
            });
            once(behavior, ".view-additional-documents .views-row", context).forEach((viewsField)=>{
                var selectorWord = ".views-field:nth-child(3) > .field-content > div.third-column-wrapper";
                $(selectorWord).addClass("show");
                $(".views-field:nth-child(3) > .field-content").each(function() {
                    var interviewArrangements = $(this).find(".interview-arrangement");
                    if (interviewArrangements.length > 1) interviewArrangements.not(":eq(0)").hide();
                });
                $(".views-field:nth-child(3)").css({
                    "height": "auto"
                });
            });
            once(behavior, ".view-interview-arrangement .views-row", context).forEach((viewsField)=>{
                var selectorWord = ".views-field:nth-child(3) > .field-content > div:first-child";
                $(selectorWord).addClass("show");
                if ($(window).width() < 767) {
                    $(".views-field-field-prog-interview-list").css({
                        "height": "auto",
                        "width": "805px"
                    });
                    $(".views-field-field-prog-addt-doc-list").css({
                        "height": "0",
                        "width": "0px",
                        "padding-top": "0"
                    });
                } else {
                    $(".views-field-field-prog-interview-list").css({
                        "height": "auto",
                        "width": "805px"
                    });
                    $(".views-field-field-prog-addt-doc-list").css({
                        "height": "0",
                        "width": "0",
                        "margin": "0"
                    });
                }
                $(".views-field:nth-child(3) > .field-content").each(function() {
                    var interviewArrangements = $(this).find(".interview-arrangement");
                    if (interviewArrangements.length > 1) interviewArrangements.not(":eq(0)").hide();
                });
                $(".views-field:nth-child(3)").css({
                    "height": "auto"
                });
            });
            once(behavior, ".additional-supporting-button", context).forEach((button)=>{
                $(button).on("click", function() {
                    if ($(window).width() < 767) {
                        $(".views-field-field-prog-interview-list").css({
                            "height": "0",
                            "width": "0",
                            "margin": "0",
                            "padding-top": "0"
                        });
                        $(".views-field-field-prog-addt-doc-list").css({
                            "height": "auto",
                            "width": "805px",
                            "padding-top": "36px"
                        });
                    } else {
                        $(".views-field-field-prog-interview-list").css({
                            "height": "0",
                            "width": "0",
                            "margin": "0"
                        });
                        $(".views-field-field-prog-addt-doc-list").css({
                            "height": "auto",
                            "width": "805px"
                        });
                    }
                    $(".views-field:nth-child(4) > .field-content > div:first-child").toggleClass("show");
                    $(".views-field:nth-child(3) > .field-content > div:first-child").toggleClass("show");
                });
            });
            once(behavior, ".interview-arrangement", context).forEach((button)=>{
                $(button).on("click", function() {
                    if ($(window).width() < 767) {
                        $(".views-field-field-prog-interview-list").css({
                            "height": "auto",
                            "width": "805px",
                            "padding-top": "36px"
                        });
                        $(".views-field-field-prog-addt-doc-list").css({
                            "height": "0",
                            "width": "0px",
                            "padding-top": "0"
                        });
                    } else {
                        $(".views-field-field-prog-interview-list").css({
                            "height": "auto",
                            "width": "805px"
                        });
                        $(".views-field-field-prog-addt-doc-list").css({
                            "height": "0",
                            "width": "0",
                            "margin": "0"
                        });
                    }
                    $(".views-field:nth-child(4) > .field-content > div:first-child").toggleClass("show");
                    $(".views-field:nth-child(3) > .field-content > div:first-child").toggleClass("show");
                });
            });
        // once(behavior, '.views-field-field-prog-addt-doc-list', context).forEach( div => {
        //    $(div).append("<div class=\"interview-arrangement\">Interview Arrangement</div>")
        // });
        }
    };
    $(function() {
        // Adds All faculties and schools into the filter bar, left hand side
        $("#select2-edit-field-prog-discipline-target-id-container").html("All Faculties and Schools");
        //JEE override
        $(".container--view--5-kinds-of-basic-info-local-non-jupas---block-9 #select2-edit-field-prog-discipline-target-id-container,.container--view--5-kinds-of-basic-info-local-non-jupas---block-10 #select2-edit-field-prog-discipline-target-id-container").html("所有专业");
    });
//
})(jQuery);


(function($) {
    const behavior = "polyu_theme.views-ar-scholarship";
    var ug_filter_count = 0;
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{
            once(behavior, ".container--view--ar-scholarship .views-exposed-form").forEach((pattern)=>{
                ar_scholarship_show_count_filter(pattern);
                ar_scholarship_wrap_second_filter(pattern);
                ar_scholarship_show_filter_button(pattern);
            });
        }
    };
    $(function() {});
    function ar_scholarship_show_filter_button(pattern) {
        const form = $(pattern);
        const show_filter_button = form.find(".show_filter");
        const second_filter = form.find(".second_filter");
        const hide_filter = 'Hide Filters <i class="fa-light fa-angle-up"></i>';
        const show_filter = "Show Filters <span class='filter-count'>" + ug_filter_count + '</span><i class="fa-light fa-angle-down"></i>';
        if (second_filter != "undefined") {
            if (second_filter.css("display") !== "none") show_filter_button.html(hide_filter);
            else show_filter_button.html(show_filter);
        }
    }
    function ar_scholarship_show_count_filter(pattern) {
        const form = $(pattern);
        const fieldset = form.find(".fieldset");
        ug_filter_count = 0;
        fieldset.find("input[type=checkbox]").each(function() {
            if ($(this).is(":checked")) ug_filter_count++;
        });
    }
    function ar_scholarship_wrap_second_filter(pattern) {
        const form = $(pattern);
        if (form.find(".first_filter").length == 0) {
            form.children().wrapAll("<div class='second_filter'><div class='container'></div></div>");
            form.prepend("<div class='first_filter'><div class='form_title'>List of Scholarships</div></div>");
            form.find(".first_filter").append('<div class="show_filter ug">Show Filters <span class="filter-count">' + ug_filter_count + '</span><i class="fa-light fa-angle-down"></i></div>');
        }
        form.find(".show_filter").on("click", function(e) {
            form.find(".second_filter").slideToggle(500, "linear", function() {
                ar_scholarship_show_filter_button(pattern);
            });
        });
    }
})(jQuery);



})();
//# sourceMappingURL=views.js.map
